import ReactPaginate from 'react-paginate';
import Button from "../../../components/UI/Button/Button"
import Input from "../../../components/UI/Input/Input"
import Password from '../../../components/OrderGrid/Password/Password';
import { useEffect, useState } from 'react';
import fetchData from '../../../shared/fetchData';
import { checkValidity, updateObject } from '../../../shared/utility';

const ShowPassword = (props) => {
    const [passwords, setPasswords] = useState([])
    const [offset, setOffset] = useState('1')
    const [perPage, setPerPage] = useState('3')
    const [pageCount, setPageCount] = useState('0')
    const [searchPass, setSearchPass] = useState({
        password: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'جستجو'
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        }
    })

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(searchPass, {
            [controlName]: updateObject(searchPass[controlName], {
                value: event.target.value,
                valid: checkValidity(event.target.value, searchPass[controlName].validation)
            })
        });
        setSearchPass(updatedControls)
    }
    useEffect(() => {
        var info = {
            "orderId": props.orderId,
            "pl": 3,
            "pn": 1,
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/orders/getOrderPasswords'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                setPasswords(result.passwords)
                setPageCount(result.count / parseInt(perPage))
            })
            .catch(error => console.log(error))
    }, [props.orderId])
    const handlePageClick = (e) => {
        setOffset(e.selected + 1)
        var info = {
            "orderId": props.orderId,
            "password": searchPass.password.value != '' ? searchPass.password.value : null,
            "pl": perPage,
            "pn": e.selected + 1,
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/orders/getOrderPasswords'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                setPasswords(result.passwords)
                setPageCount(result.count / parseInt(perPage))
            })
            .catch(error => console.log(error))
    }
    const searchPasswords = (event) => {
        var info = {
            "orderId": props.orderId,
            "password": searchPass.password.value != '' ? searchPass.password.value : null,
            "pl": perPage,
            "pn": "1",
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/orders/getOrderPasswords'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                setPasswords(result.passwords)
                setPageCount(result.count / parseInt(perPage))
            })
            .catch(error => console.log(error))
    }
    const reloadPasswords = (e) => {
        var info = {
            "orderId": props.orderId,
            "password": searchPass.password.value != '' ? searchPass.password.value : null,
            "pl": perPage,
            "pn": offset,
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/orders/getOrderPasswords'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                setPasswords(result.passwords)
                setPageCount(result.count / parseInt(perPage))
            })
            .catch(error => console.log(error))
    }

    const formElementsArray = [];
    for (let key in searchPass) {
        formElementsArray.push({
            id: key,
            config: searchPass[key]
        });
    }
    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                col="4 p-0 mt-3"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    });
    return (
        <div className="pass-container">
            <div className="row justify-content-center mr-0 ml-0 mt-3">
                {form}
                <div className="col-4 p-0 mt-3">
                    <Button className="pass-search" btnType="Success" clicked={searchPasswords} >جستجو</Button>
                </div>
            </div>
            {passwords != null && passwords.length != 0 ?
                passwords.map(p => {
                    return (
                        <div className="row justify-content-center mt-3">
                            <Password reloadPasswords={reloadPasswords} password={p} closeModal={props.closeModal} />
                        </div>
                    )
                })
                :
                <div className="row justify-content-center mt-3 mb-3">
                    هیچ رمزی یافت نشد!
                </div>
            }
            {passwords != null && passwords.length != 0 ?
                <div className="row justify-content-center">
                    <ReactPaginate
                        previousLabel={"→قبلی"}
                        nextLabel={"بعدی←"}
                        forcePage={offset >= 0 ? offset - 1 : offset}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName="pagination"
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"} />
                </div>
                : ''}
            <div className="row justify-content-center mt-3">
                <Button btnType="General" clicked={props.closeModal} >برگشت</Button>
            </div>
        </div>
    )
}
export default ShowPassword;